import { Box, Table, TableBody, TableRow, TableCell, DialogTitle, IconButton, Stack, Typography, Divider } from '@mui/material';

import React, {} from 'react';

import { AddCircleSharp, ArrowForwardIosSharp, Cancel } from '@mui/icons-material';
import __t from '../../../lib/traduzioni';
import useBSSLogger from '../../../hooks/useBSSLogger';
import BSSDrawer from '../../form/BSSDrawer';


const {logger} = useBSSLogger();

const DrawerMisurePredefinite = ({
    drawerTipiColli,
    setDrawerTipiColli,
    misurePredefinite,
    codiceTipo,
    selezionaMisura,
    subTitleTipiColli,
    setOpenDialogNuovaMisura

}) => {

    return (
        <>
            <BSSDrawer style={{ zIndex: 9999 }} anchor="left" open={drawerTipiColli.open} onClose={e => setDrawerTipiColli({...drawerTipiColli, open: false})}>
                
                <DialogTitle disableTypography className="drawerTitle" sx={{display: "flex", justifyContent: "flex-end", padding: "0"}}>
                    <IconButton size={"large"} onClick={e => setDrawerTipiColli({...drawerTipiColli, open: false})}>
                        <Cancel color="secondary" />
                    </IconButton>
                </DialogTitle>



                <Box pl={2}>
                    {/* <Button onClick={e => aggiornaPreferenze()}>Aggiorna preferenze</Button> */}
                    <h3>{__t("misurepredef")} {codiceTipo} {" "}
                        <IconButton onClick={e => {setOpenDialogNuovaMisura(true)}} size={"small"}><AddCircleSharp color={"primary"} /></IconButton>
                    </h3>
                    

                    
                    {misurePredefinite && (
                        <Table size="small">
                            <TableBody>
                                {(misurePredefinite[codiceTipo] ?? []).map((option, indice) => {                                    

                                    return (

                                        <TableRow onClick={e => selezionaMisura(option)} 
                                            sx={{cursor: "pointer", ":hover": {
                                                backgroundColor: "grey.300"
                                            }}} 
                                            key={indice}>
                                            <TableCell align="left">
                                                <Stack>
                                                    {option.codice}
                                                    <Divider />
                                                    <Typography variant="caption">
                                                        {subTitleTipiColli(option)}
                                                    </Typography>
                                                </Stack>
                                            </TableCell>
                                            <TableCell align="right">
                                                <IconButton onClick={e => {selezionaMisura(option)}} size={"small"}><ArrowForwardIosSharp color={"primary"} /></IconButton>

                                            </TableCell>
                                        </TableRow>
                                        
                                    )                            
                            })}
                            </TableBody>                                
                        </Table> 
                    )}

                </Box>
            </BSSDrawer>
        </>
    )
}

export default DrawerMisurePredefinite;